let ReactBootstrap: any = {};
try {
  ReactBootstrap = require('react-bootstrap');
} catch (err) {}

export default ReactBootstrap;
